// Shopify Theme JavaScript for Breaking Free From Your Nafs
document.addEventListener('DOMContentLoaded', () => {

  // 1. COUNTDOWN TIMER (Evergreen 24-hour sync with localStorage)
  const TIMER_STORAGE_KEY = 'break_free_nafs_timer_start';
  const DURATION_MS = 24 * 60 * 60 * 1000;
  const now = Date.now();
  let startTime = parseInt(localStorage.getItem(TIMER_STORAGE_KEY) || '', 10);

  if (isNaN(startTime) || now - startTime > DURATION_MS) {
    startTime = now;
    localStorage.setItem(TIMER_STORAGE_KEY, startTime.toString());
  }

  const targetTime = startTime + DURATION_MS;

  function updateTimers() {
    const current = Date.now();
    const remaining = Math.max(0, targetTime - current);

    const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((remaining / (1000 * 60)) % 60);
    const seconds = Math.floor((remaining / 1000) % 60);

    const pad = (n) => String(n).padStart(2, '0');

    document.querySelectorAll('.timer-days').forEach(el => el.textContent = pad(days) + (el.dataset.suffix || ''));
    document.querySelectorAll('.timer-hours').forEach(el => el.textContent = pad(hours) + (el.dataset.suffix || ''));
    document.querySelectorAll('.timer-mins').forEach(el => el.textContent = pad(minutes) + (el.dataset.suffix || ''));
    document.querySelectorAll('.timer-secs').forEach(el => el.textContent = pad(seconds) + (el.dataset.suffix || ''));
  }

  updateTimers();
  setInterval(updateTimers, 1000);

  // 2. HERO IMAGE GALLERY SWITCHER
  const mainImg = document.getElementById('hero-main-image');
  const thumbs = document.querySelectorAll('.gallery-thumb');

  thumbs.forEach(btn => {
    btn.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      btn.classList.add('active');
      const src = btn.getAttribute('data-src');
      if (mainImg && src) {
        mainImg.src = src;
      }
    });
  });

  // 3. FAQ ACCORDION TOGGLE
  document.querySelectorAll('.faq-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const parent = btn.closest('.faq-item');
      const answer = parent.querySelector('.faq-answer');
      const icon = parent.querySelector('.faq-icon');

      const isHidden = answer.classList.contains('hidden');
      if (isHidden) {
        answer.classList.remove('hidden');
        if (icon) icon.textContent = '−';
      } else {
        answer.classList.add('hidden');
        if (icon) icon.textContent = '+';
      }
    });
  });

  // 4. DYNAMIC 105 REVIEWS FILTERING, SEARCH & PAGINATION
  const reviewsDataScript = document.getElementById('shopify-reviews-data');
  if (reviewsDataScript) {
    try {
      const allReviews = JSON.parse(reviewsDataScript.textContent.trim());
      let currentFilter = 'all';
      let currentSearch = '';
      let displayCount = 8;

      const grid = document.getElementById('reviews-grid');
      const countStatus = document.getElementById('reviews-count-status');
      const loadMoreBtn = document.getElementById('reviews-load-more');
      const viewAllBtn = document.getElementById('reviews-view-all');
      const clearSearchBtn = document.getElementById('reviews-clear-search');
      const searchInput = document.getElementById('reviews-search-input');
      const filterButtons = document.querySelectorAll('#reviews-filter-buttons .filter-btn');

      const hinglishKeywords = ['bhai', 'namaz', 'taubah', 'bohot', 'khatam', 'fajr', 'aadat', 'dil', 'pehle', 'chhod', 'sukoon', 'allah', 'gunah'];

      function getFilteredReviews() {
        return allReviews.filter(r => {
          const fullText = (r.title + ' ' + r.text).toLowerCase();
          
          if (currentFilter === 'fivestar' && r.rating !== 5) return false;
          if (currentFilter === 'hinglish') {
            const hasHinglish = hinglishKeywords.some(w => fullText.includes(w));
            if (!hasHinglish) return false;
          }
          if (currentFilter === 'english') {
            const hasHinglish = hinglishKeywords.some(w => fullText.includes(w));
            if (hasHinglish) return false;
          }

          if (currentSearch) {
            const q = currentSearch.toLowerCase();
            const matches = r.name.toLowerCase().includes(q) ||
                            (r.location && r.location.toLowerCase().includes(q)) ||
                            r.title.toLowerCase().includes(q) ||
                            r.text.toLowerCase().includes(q);
            if (!matches) return false;
          }

          return true;
        });
      }

      function renderReviews() {
        const filtered = getFilteredReviews();
        const visible = filtered.slice(0, displayCount);

        if (!grid) return;
        grid.innerHTML = visible.map(r => `
          <div class="min-w-[280px] sm:min-w-0 snap-start bg-white p-5 rounded-2xl border border-[#E8E5DF] hover:border-[#B8924A]/60 shadow-2xs hover:shadow-sm transition flex flex-col justify-between">
            <div>
              <div class="flex items-center justify-between gap-2 mb-3">
                <div>
                  <h4 class="text-xs font-bold text-[#1A1A1A]">${r.name}</h4>
                  <span class="text-[10px] text-stone-400 block">${r.location || ''}</span>
                </div>
                ${r.isVerified ? `
                  <span class="inline-flex items-center gap-1 text-[10px] font-semibold text-emerald-800 bg-emerald-50 px-2 py-0.5 rounded-full border border-emerald-200/60 shrink-0">
                    <svg class="w-3.5 h-3.5 text-emerald-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                    <span>Verified</span>
                  </span>
                ` : ''}
              </div>

              <div class="flex text-amber-400 gap-0.5 mb-2">
                ${'<svg class="w-3.5 h-3.5 fill-amber-400 text-amber-400" viewBox="0 0 20 20" fill="currentColor"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>'.repeat(r.rating || 5)}
              </div>

              <h5 class="text-xs font-bold text-stone-900 mb-1.5 leading-snug">${r.title}</h5>
              <p class="text-xs text-stone-600 leading-relaxed italic">"${r.text}"</p>
            </div>

            ${r.date ? `<div class="pt-3 mt-3 border-t border-stone-100 text-[10px] text-stone-400 font-mono">${r.date}</div>` : ''}
          </div>
        `).join('');

        if (countStatus) {
          countStatus.textContent = `Showing ${visible.length} of ${filtered.length} verified reviews`;
        }

        if (loadMoreBtn) {
          loadMoreBtn.style.display = filtered.length > displayCount ? 'inline-block' : 'none';
        }
        if (viewAllBtn) {
          viewAllBtn.style.display = filtered.length > displayCount ? 'inline-block' : 'none';
        }
      }

      // Filter tabs event listeners
      filterButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          filterButtons.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          currentFilter = btn.getAttribute('data-filter') || 'all';
          displayCount = 8;
          renderReviews();
        });
      });

      // Search input event listener
      if (searchInput) {
        searchInput.addEventListener('input', (e) => {
          currentSearch = e.target.value.trim();
          displayCount = 8;
          if (clearSearchBtn) clearSearchBtn.classList.toggle('hidden', !currentSearch);
          renderReviews();
        });
      }

      if (clearSearchBtn) {
        clearSearchBtn.addEventListener('click', () => {
          if (searchInput) searchInput.value = '';
          currentSearch = '';
          clearSearchBtn.classList.add('hidden');
          displayCount = 8;
          renderReviews();
        });
      }

      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', () => {
          displayCount += 12;
          renderReviews();
        });
      }

      if (viewAllBtn) {
        viewAllBtn.addEventListener('click', () => {
          displayCount = allReviews.length;
          renderReviews();
        });
      }

      // Initial render
      renderReviews();

    } catch (err) {
      console.error('Failed to parse reviews data:', err);
    }
  }

  // 5. MOBILE STICKY BAR VISIBILITY (Triggered when scrolling past hero section)
  const mobileBar = document.getElementById('shopify-mobile-sticky-bar');
  if (mobileBar) {
    window.addEventListener('scroll', () => {
      const scrollPos = window.scrollY;
      if (scrollPos > 400) {
        mobileBar.classList.remove('translate-y-full');
      } else {
        mobileBar.classList.add('translate-y-full');
      }
    });
  }

});
